module.exports = __webpack_public_path__ + "assets/img/4_73_big.21384211.jpg";